import { ensureFreshToken, isKeycloakMode } from './keycloakClient';
import { getStoredAccessToken } from '../utils/tokenStorage';

export async function getBearerToken() {
  if (isKeycloakMode()) {
    const t = await ensureFreshToken(30);
    return t || null;
  }
  return getStoredAccessToken();
}
